import { GiftSvg } from "./GiftSvg";
import { StarSvg } from "./StarSvg";
import { ChatSvg } from "./ChatSvg";
import { OpenSvg } from "./OpenSvg";
import { PlaySvg } from "./PlaySvg";
import { UserSvg } from "./UserSvg";
import { PlusSvg } from "./PlusSvg";
import { VideoSvg } from "./VideoSvg";
import { HeartSvg } from "./HeartSvg";
import { ClockSvg } from "./ClockSvg";
import { CloseSvg } from "./CloseSvg";
import { CheckSvg } from "./CheckSvg";
import { GoogleSvg } from "./GoogleSvg";
import { EyeOffSvg } from "./EyeOffSvg";
import { WalletSvg } from "./WalletSvg";
import { FilterSvg } from "./FilterSvg";
import { MyCourses } from "./MyCourses";
import { GoBackSvg } from "./GoBackSvg";
import { SearchSvg } from "./SearchSvg";
import { LogOutSvg } from "./LogOutSvg";
import { PlayBtnSvg } from "./PlayBtnSvg";
import { BtnPlaySvg } from "./BtnPlaySvg";
import { TwitterSvg } from "./TwitterSvg";
import { ViewAllSvg } from "./ViewAllSvg";
import { HomeTabSvg } from "./HomeTabSvg";
import { ShowMoreSvg } from "./ShowMoreSvg";
import { GraduateSvg } from "./GraduateSvg";
import { DownloadSvg } from "./DownloadSvg";
import { FileTextSvg } from "./FileTextSvg";
import { FacebookSvg } from "./FacebookSvg";
import { SmallPlaySvg } from "./SmallPlaySvg";
import { HelpCirceSvg } from "./HelpCirceSvg";
import { SearchTabSvg } from "./SearchTabSvg";
import { InputCheckSvg } from "./InputCheckSvg";
import { PercentOffSvg } from "./PercentOffSvg";
import { RightArrowSvg } from "./RightArrowSvg";
import { ProfileTabSvg } from "./ProfileTabSvg";
import { CertificateSvg } from "./CertificateSvg";
import { LocationSvg } from "./MyLocaiton";
import { BookingSvg } from "./Booking";
import { BookingSvg_Green } from "./Booking";
import { CallSvg } from "./CallSvg";
import { LoanSvg } from "./LoanSvg";
import { BackToHome } from "./BackToHome";
import { HomeTabSvg2 } from "./HomeTabSvg2";

export const svg = {
  GiftSvg,
  StarSvg,
  OpenSvg,
  UserSvg,
  PlaySvg,
  ChatSvg,
  PlusSvg,
  HeartSvg,
  ClockSvg,
  CloseSvg,
  CheckSvg,
  VideoSvg,
  GoogleSvg,
  WalletSvg,
  MyCourses,
  SearchSvg,
  GoBackSvg,
  LogOutSvg,
  EyeOffSvg,
  FilterSvg,
  TwitterSvg,
  PlayBtnSvg,
  BtnPlaySvg,
  ViewAllSvg,
  HomeTabSvg,
  HomeTabSvg2,
  ShowMoreSvg,
  DownloadSvg,
  GraduateSvg,
  FileTextSvg,
  FacebookSvg,
  HelpCirceSvg,
  SmallPlaySvg,
  SearchTabSvg,
  ProfileTabSvg,
  InputCheckSvg,
  RightArrowSvg,
  PercentOffSvg,
  CertificateSvg,
  LocationSvg,
  BookingSvg,
  BookingSvg_Green,
  CallSvg,
  LoanSvg,
  BackToHome,
};
